import React from 'react';

import { Button, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';

interface PasswordOverlayProps {
  validatingPassword: boolean;
  passwordError: string | null;
  onValidate: (values: { password: string }) => void;
}

const PasswordOverlay: React.FC<PasswordOverlayProps> = ({
  validatingPassword,
  passwordError,
  onValidate,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  return (
    <div className="password-overlay">
      <div className="password-prompt-container">
        <h3>{t('scenes.power_bi_report.password_modal.title')}</h3>
        <p>{t('scenes.power_bi_report.password_modal.description')}</p>
        <Form form={form} onFinish={onValidate} layout="vertical">
          <Form.Item
            name="password"
            label={t('scenes.power_bi_report.password_modal.password_label')}
            rules={[
              {
                required: true,
                message: t(
                  'scenes.power_bi_report.password_modal.required_error'
                ),
              },
            ]}
            style={{
              marginBottom: passwordError ? '10px' : '48px',
            }}
          >
            <Input.Password
              placeholder={t(
                'scenes.power_bi_report.password_modal.password_placeholder'
              )}
              disabled={validatingPassword}
              autoFocus
            />
          </Form.Item>

          {passwordError && (
            <div
              style={{
                color: '#ff4d4f',
                marginBottom: '16px',
                fontSize: '14px',
                fontWeight: 500,
              }}
            >
              {passwordError}
            </div>
          )}

          <Form.Item style={{ marginBottom: 0 }}>
            <Button
              type="primary"
              block
              loading={validatingPassword}
              htmlType="submit"
              style={{
                borderRadius: '6px',
                fontWeight: 600,
              }}
            >
              {t('scenes.power_bi_report.password_modal.submit_button')}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default PasswordOverlay;
